"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCustomerUrl = getCustomerUrl;

var _http = require("../lib/http");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cacheCustomUrl = {};
/**
 * 获取直播间客服链接(相同直播间，多次请求会缓存。)
 */

function getCustomerUrl(env, params) {
  var cacheKey = params.type + params.id;

  if (!!cacheCustomUrl[cacheKey]) {
    return cacheCustomUrl[cacheKey];
  }

  var result = getCustomerUrlRaw(env, params);
  cacheCustomUrl[cacheKey] = result;
  result["catch"](function (err) {
    delete cacheCustomUrl[cacheKey];
  });
  return result["catch"](function (res) {
    console.log('getCustomerUrl', res);
    return {
      customer_url: ''
    };
  });
}
/**
 * 获取客服链接
 */


function getCustomerUrlRaw(env, params) {
  var http = (0, _http.setupApiRequestExt)(env);
  return http.get('/v1/integration/cont_manager/v1/api/liveroom.shunt.customer_url.get', {
    params: _defineProperty({}, params.type, params.id)
  }).then(function (res) {
    return res.data;
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/@weike/services/lib/services/customer.js
// module id = 628
// module chunks = 4